import { Close } from "@mui/icons-material";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    IconButton,
    Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import { sendAadharOtp } from "services/otpService";

interface OtpDialogPropTypes {
  handleClose: () => void;
  handleVerification: (otp: string) => void;
}

const OtpDialog = ({handleClose, handleVerification}: OtpDialogPropTypes) => {
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(45); 

   const handleResendClick = () => {
     setTimer(45); // Reset the timer
    //  sendAadharOtp(aadhaar, setIsOtpDialogOpen, dispatch);
   };

   useEffect(() => {
       let interval: NodeJS.Timeout | null = null;
   
       if (timer > 0) {
         interval = setInterval(() => {
           setTimer((prev) => prev - 1);
         }, 1000);
       } else if (interval) {
         clearInterval(interval);
       }
   
       return () => {
         if (interval) clearInterval(interval);
       };
     }, [timer]);

  return (
    <Dialog open maxWidth="md" onClose={handleClose} PaperProps={{ sx: { borderRadius: 4, m: {xs: 2, md: 4} } }}>
      <IconButton sx={{ position: "absolute", top: 10, right: 10 }}>
        <Close onClick={handleClose} />
      </IconButton>
      <Box p={6} pb={40} sx={{p: {xs: 2, md: 6}, pb: {xs: 20, md: 40}, }} minHeight={400}>
        <Typography fontWeight={500} variant="h4">
          Enter Verification Code
        </Typography>
        <Typography color="#979797" fontSize={18} mt={1}>
          A verification code has been sent to your registerd mobile number. 
        </Typography>

        <OtpInput
          value={otp}
          onChange={setOtp}
          numInputs={6}
          renderInput={(props) => <input {...props} />}
          containerStyle={{display: "flex", justifyContent: "space-between", margin: "40px 0"}}
          inputStyle={{width: 50, height: 50, fontSize: 18, border: "1px solid #979797", borderRadius: 6}}
        />
          <Box display="flex" justifyContent="space-between">
        <Typography color="text.secondary"
        sx={{
          cursor:'pointer'
        }}
        >
            Didn’t get a code?{" "}
            {timer > 0 ? (
              <span>{timer}s</span>
            ) : (
              <span
                style={{ textDecoration: "underline", cursor: "pointer" }}
                onClick={handleResendClick}
              >
                Resend Code
              </span>
            )}
          </Typography>

          <Button variant="contained"
              disabled={otp.length !== 6}
              onClick={() => handleVerification(otp)}
            >Verify</Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default OtpDialog;


